import { Box, Grid } from '@chakra-ui/react'
import styled from '@emotion/styled'

import theme from 'styles/theme'

export const TimePickerWrapper = styled(Box)<{ defaultVisible: boolean }>`
  display: ${({ defaultVisible }) => (defaultVisible ? 'block' : 'none')};
  height: 100%;
  padding-top: 16px;

  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  background-color: ${theme.token.var('colors.green.a25')};
  opacity: ${({ defaultVisible }) => (defaultVisible ? 1 : 0)};
  transform: scale(${({ defaultVisible }) => (defaultVisible ? 1 : 0.8)});
  transform-origin: 50% 50%;
  will-change: opacity, transform;

  &.fade {
    &-enter {
      opacity: 0;
      transform: scale(0.8);
      display: block;
      transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;

      &-active {
        opacity: 1;
        transform: scale(1);
        display: block;
        transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
      }

      &-done {
        opacity: 1;
        transform: scale(1);
        display: block;
      }
    }

    &-exit {
      opacity: 1;
      transform: scale(1);
      display: block;
      transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;

      &-active {
        opacity: 0;
        transform: scale(0.8);
        display: block;
        transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
      }

      &-done {
        opacity: 0;
        transform: scale(0.8);
        display: none;
      }
    }
  }
`

export const TimePickerGrid = styled(Grid)`
  height: 100%;
  grid-template-columns: repeat(4, 1fr);
  gap: 4px;
`
